import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App/App";
import Providers from "./components/Providers";
import "./index.css";

const rootElement = document.getElementById("root");

const theme = createTheme();

theme.typography.h3 = {
  fontFamily: "'Inter', sans-serif",
  typography: {
    fontFamily: ["'Inter'", "sans-serif"],
  },
};

ReactDOM.render(
  <React.StrictMode>
    <Providers>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </Providers>
  </React.StrictMode>,
  rootElement
);
